/** Player commands. These are the only way player intent enters the simulation. */

export type FormationType = 'none' | 'line' | 'column' | 'box' | 'wedge' | 'square' | 'loose';
export const FORMATIONS: FormationType[] = ['none', 'line', 'column', 'box', 'wedge', 'square', 'loose'];

export type Stance = 'aggressive' | 'defensive' | 'hold' | 'passive';

export type Command =
  | { t: 'move'; ids: number[]; x: number; y: number; attackMove?: boolean; formation?: FormationType; queue?: boolean }
  | { t: 'attack'; ids: number[]; target: number }
  | { t: 'gather'; ids: number[]; target: number }
  | { t: 'build'; ids: number[]; kind: string; tx: number; ty: number; queue?: boolean }
  /** A line of wall pieces [kind, tx, ty], built in order; pieces that cannot be placed are skipped. */
  | { t: 'buildWall'; ids: number[]; pieces: [string, number, number][]; queue?: boolean }
  | { t: 'repair'; ids: number[]; target: number }
  | { t: 'train'; building: number; kind: string; count: number }
  | { t: 'research'; building: number; tech: string }
  | { t: 'capture'; ids: number[]; target: number }
  /** Go inside a building or board a transport ship. */
  | { t: 'garrison'; ids: number[]; target: number }
  /**
   * Let the units out of buildings, or send transports to land their cargo near (x, y) (default:
   * where they are). `resume`: units leaving a building go back to what they were doing before.
   */
  | { t: 'unload'; ids: number[]; x?: number; y?: number; resume?: boolean }
  | { t: 'cancel'; building: number; index: number }
  | { t: 'rally'; building: number; x: number; y: number; target?: number }
  | { t: 'stop'; ids: number[] }
  | { t: 'stance'; ids: number[]; stance: Stance }
  | { t: 'patrol'; ids: number[]; x: number; y: number }
  | { t: 'guard'; ids: number[]; target: number }
  | { t: 'follow'; ids: number[]; target: number }
  | { t: 'retreat'; ids: number[] }
  | { t: 'delete'; ids: number[] }
  | { t: 'trade'; res: number; buy: boolean }
  | { t: 'resign' }
  /** Coordinated multiplayer save: every peer saves its own copy at the same tick. */
  | { t: 'saveGame'; name: string }
  | { t: 'autoReseed'; on: boolean };

export interface CommandEnvelope {
  /** Simulation tick at which the command executes. */
  tick: number;
  player: number;
  /** Per-player monotonically increasing sequence number (deduplication). */
  seq: number;
  cmd: Command;
}

/** Max entity ids per command; guards against oversized network payloads. */
export const MAX_COMMAND_IDS = 200;
